const styles = theme => ({
  root: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    flexDirection: 'column',
    minHeight: '90px',
    height: 'auto',
  },
  textfield: {
    '& fieldset': { border: 'none' },
    width: '100%',
    maxWidth: '752px',
    marginLeft: '64px',
    marginBottom: '8px',
    padding: 0,
  },
  textfieldWithSettings: {
    marginLeft: '96px',
  },
  textfieldInput: {
    color: '#002E47',
    fontWeight: 600,
    fontSize: '32px',
    lineHeight: '42px',
    textAlign: 'center',
    padding: 0,
    fontFamily: 'inherit', // This will allow the font to be overridden
  },
  divider: {
    backgroundColor: '#015FFB',
    width: '280px',
    marginBottom: '8px',
    height: '3px',
  },
  pasteBarContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: '752px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 20px',
    borderRadius: '8px',
    border: '1px dashed #002E47',
    backgroundColor: '#F4F6F8',
    marginTop: '16px',
    marginBottom: '16px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      gap: '12px',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  pasteBarInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    minWidth: 0,
  },
  pasteIcon: {
    fontSize: '24px',
    color: '#002E47',
    flexShrink: 0,
  },
  pasteText: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '22px',
    color: '#002E47',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      whiteSpace: 'normal',
    },
  },
  pasteButton: {
    height: '32px',
    border: 'none',
    borderRadius: '6px',
    backgroundColor: '#002E47',
    color: '#FFFFFF',
    fontFamily: 'Inter, sans-serif',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '18px',
    padding: '7px 12px',
    cursor: 'pointer',
    flexShrink: 0,
    '&:hover': {
      backgroundColor: '#001f31',
    },
    '&:focus-visible': {
      outline: '2px solid #015FFB',
      outlineOffset: '2px',
    },
  },
  dismissButton: {
    position: 'absolute',
    top: '-9px',
    right: '-9px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '18px',
    height: '18px',
    border: 'none',
    borderRadius: '50%',
    backgroundColor: '#002E47',
    color: '#FFFFFF',
    cursor: 'pointer',
    padding: 0,
    fontSize: '12px',
    '&:hover': {
      backgroundColor: '#001f31',
    },
    '&:focus-visible': {
      outline: '2px solid #015FFB',
      outlineOffset: '2px',
    },
  },
  player: {
    display: 'flex',
    width: '752px',
    height: '64px',
    padding: '12px 16px',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: '12px',
    border: '1px solid var(--Gray-Lighter, #E5E7EB)',
    background: 'var(--mcg-white, #FFF)',
  },
})

export default styles
